import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { startLogout } from '../actions/auth';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';

const Header = (props) => {

    const primary=orange[800];
    const navigate=useNavigate();

    return (
        <header className='header col-md-3 col-12 d-flex flex-column text-center justify-content-between align-items-center'>
            
            <div className="app-details">
                <img src="./images/icon.png" className="extensify-icon" alt="" />
                <Link to='/dashboard'>
                    <h1 className='app-name'>Extensify</h1>
                </Link>
                <p className='app-detail'>It's time to get your expenses under control.</p>
            </div>

            <div className="user-details">
                <img src={props.image} />
                <h1>{props.name}</h1>
                <p>{props.email}</p>
            

                <hr className='partition' />

                <Button 
                    variant='contained'
                    className='login-logout-button'
                    style={{backgroundColor:primary}}
                    onClick={async ()=>{
                        await props.startLogout();
                        navigate('/');
                    }}
                >Logout</Button>
            </div>
        </header>
    );
};

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
});

const mapStateToProps = (state) => ({
    name: state.auth.displayName,
    email: state.auth.email,
    image: state.auth.photoUrl
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);